export const rootNode = document.getElementById('smart-search-report-root');

const parseRootNode = (dataName, defaultValue) =>
  rootNode.dataset[dataName] ? JSON.parse(rootNode.dataset[dataName]) : defaultValue;

export const initParams = {
  popularApps: parseRootNode('topPopularApps', []),
  preSelectedApp: parseRootNode('appsGeneralData', []),
  customTitles: parseRootNode('customTitles', {}),
  updatedReportStep: parseRootNode('reportUpdatedState', false),
  sharedByReportId: rootNode.dataset.sharedByReportId,
  sitekey: rootNode.dataset.sitekey,
};
